import get from "lodash/get";
import { useSelector } from "react-redux";
export var useIntegrationName = function () {
    return useSelector(function (state) { return get(state, 'appReducer.integrationName'); });
};
